import {Component, OnDestroy, OnInit} from '@angular/core';
import {User} from 'src/app/models/user.model';
import {UserGroup} from 'src/app/models/user-group.model';
import {Permission} from 'src/app/models/permission.model';
import {AppService} from 'src/app/app.service';
import {UserSettingsService} from './user-settings.service';

@Component({
  selector: 'fx-user-settings',
  templateUrl: './user-settings.component.html',
  styleUrls: ['./user-settings.component.sass']
})
export class UserSettingsComponent implements OnInit, OnDestroy {
  permission: Permission;
  users: User[];
  groups: UserGroup[];
  subscription: any = {};

  constructor(private appService: AppService,
              private userSettingsService: UserSettingsService) {
    this.permission = this.appService.getCurrentPermission(location.pathname);
    this.getGroups();
  }

  ngOnInit(): void {
  }

  onGroupLoaded(groups: any): void {
    this.getGroups();
  }

  getGroups(): void {
    this.subscription.getGroups = this.userSettingsService
      .getGroups()
      .subscribe(data => {
        this.groups = data.data;
      });
  }

  ngOnDestroy(): void {
    for (const key in this.subscription) {
      if (this.subscription.hasOwnProperty(key) && this.subscription[key]) {
        this.subscription[key].unsubscribe();
      }
    }
  }
}
